import type { Msg, Session } from '@halo/chat-sdk-react';
import { Center } from '@chakra-ui/react';
import { ItemExpireContext as MessageExpireContext, MessageMetaRoot } from '@halo/ui-chat-react';
import { Emoji } from '@/components/Emoji';
import {
  MsgAvatar,
  MsgBody,
  MsgExpireAnimate,
  MsgFooter,
  MsgFooterEdit,
  MsgFooterReplies,
  MsgForwardFrom,
  MsgHeader,
  MsgItem,
  MsgMenuTrigger,
  MsgReadStatus,
  MsgReply,
} from '../../msg-parts';
import { MsgTextContent } from './msg-text-content';
import { MsgTextBubble } from './msg-text-bubble';

// Message
export interface MsgTextProps {
  session: Session;
  message: Msg;
}

export const MsgText = memo(function MsgText({ session, message }: MsgTextProps) {
  return (
    <MsgItem message={message}>
      <MessageExpireContext message={message}>
        <MsgAvatar message={message} session={session} />
        <MsgBody message={message}>
          <MsgHeader message={message} session={session} />
          <MsgMenuTrigger message={message}>
            <MsgExpireAnimate session={session} message={message}>
              <MsgTextBubble message={message}>
                {message.msg_ext?.forwardUid && (
                  <MsgForwardFrom forwardUid={message.msg_ext.forwardUid} />
                )}
                {message.link_msg_id && (
                  <MsgReply session={session} link_msg_id={message.link_msg_id} />
                )}
                <MsgTextContent message={message}></MsgTextContent>
                <MessageMetaRoot>
                  <Emoji.MessageMeta chat_id={session.chat_id} message={message} />
                  <Center marginLeft="auto" gap="1.5">
                    <MsgReadStatus message={message} session={session} />
                  </Center>
                </MessageMetaRoot>
              </MsgTextBubble>
            </MsgExpireAnimate>
          </MsgMenuTrigger>
          <MsgFooter message={message}>
            <MsgFooterEdit session={session} message={message} />
            <MsgFooterReplies message={message} />
          </MsgFooter>
        </MsgBody>
      </MessageExpireContext>
    </MsgItem>
  );
});
